export const capitalizeFirstLetter = (string = '') => {
  if (!string.length) {
    return string;
  }

  return `${string[0].toUpperCase()}${string.slice(1)}`;
};

export const joinTranslations = (translateFn, translations, andTranslation, prefix, altPrefix) => {
  return translations.reduce((acc, translation, index) => {
    if (index === 0) {
      const prefixTranslation = prefix ? translateFn(prefix) : '';

      return `${prefixTranslation} ${translation}`;
    }

    if (index < translations.length - 1) {
      return `${acc}, ${translation}`;
    }

    const altPrefixTranslation = altPrefix ? `${translateFn(altPrefix)} ${translation}` : translation;

    return `${acc} ${andTranslation} ${altPrefixTranslation}`;
  }, []);
};

export const sentencify = (sentences, conjunction, separator = ',') => {
  const lastSentence = sentences.pop();

  return sentences.join(`${separator} `).concat([` ${conjunction} ${lastSentence}`]);
};
